var React = require('react');

function Faucet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74l32,3.38Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384,112.89v30.22c0,10-8.17,17.8-17.59,16.8L224,144.88l-142.41,15c-9.42,1-17.59-6.81-17.59-16.8V112.89c0-10,8.17-17.8,17.59-16.8l142.41,15,142.41-15C375.83,95.09,384,102.9,384,112.89Z","className":"fa-primary","key":2})]);
}

Faucet.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Faucet;

Faucet.default = Faucet;
